import { atom } from "recoil";
import { Invoice } from "../model";

export const lastInvoiceUpdatedState = atom<Invoice | undefined>({
  key: "lastInvoiceUpdatedState",
  default: undefined
})